import { useSelect } from "@refinedev/antd";
import { ISupplier } from "interfaces";
import { APP_WRITE_SUPPLIER_ID } from "utility/constants";

export const SupplierSelectOptions = () => {
  const { selectProps: supplierSelectProps } = useSelect<ISupplier>({
    resource: APP_WRITE_SUPPLIER_ID,
    optionLabel: "Name",
    optionValue: "id",
    sorters: [
      {
        field: "Name",
        order: "asc",
      },
    ],
  });
  return (
    {supplierSelectProps}
  );
};